import { useContext } from 'react';
import { AppLayout, Portal } from '@sixui/ui';
import { paperBaseTokens } from '@sixui/ui/components/PaperBase/PaperBase.stylex';
import { sideSheetContentTokens } from '@sixui/ui/components/SideSheetContent/SideSheetContent.stylex';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import { DashboardContext } from '~/components/templates/DashboardContext';

export type IAsideProps = React.ComponentProps<typeof AppLayout.Aside> & {
  children: React.ReactNode;
};

const styles = stylex.create({
  aside: {
    [paperBaseTokens.containerColor]: colorSchemeTokens.surfaceContainerLow,
    [sideSheetContentTokens.dividerColor]: colorSchemeTokens.outlineVariant,
  },
});

export const Aside: React.FC<IAsideProps> = (props) => {
  const { children, ...other } = props;
  const dashboardContext = useContext(DashboardContext);

  if (!dashboardContext?.asideElement) {
    return null;
  }

  return (
    <Portal root={dashboardContext.asideElement}>
      <AppLayout.Aside {...other} divider sx={styles.aside}>
        {children}
      </AppLayout.Aside>
    </Portal>
  );
};
